export default __webpack_public_path__ + "static/media/cross.a40517b6.svg";